// src/components/sale-page/AreaAskModal.tsx
// popup "พื้นที่จัดส่งพิเศษ ต้องตรวจสอบค่าจัดส่ง" บนเซลเพจ (requirement 2026-09-07)
// เด้งตอนลูกค้ากด "สั่งซื้อ" เมื่อที่อยู่ตรงพื้นที่ที่ร้านระบุค่าส่งไม่ได้ —
// ข้อความมาจากร้าน (Shop.areaAskMessage) รองรับขึ้นบรรทัดใหม่ทั้ง \n และ <br>
// ใช้ร่วมกัน InlineCheckout + หน้า /checkout — แก้ที่นี่ที่เดียว

'use client'

interface Props {
  open: boolean
  message: string
  primaryColor?: string
  onConfirm: () => void
  onCancel: () => void
}

function splitLines(message: string): string[] {
  return message.replace(/<br\s*\/?>/gi, '\n').split('\n')
}

export default function AreaAskModal({ open, message, primaryColor, onConfirm, onCancel }: Props) {
  if (!open) return null
  const lines = splitLines(message)
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="area-ask-title"
    >
      <div className="w-full max-w-sm rounded-2xl bg-white p-5 shadow-2xl">
        <div className="flex items-start gap-3">
          <div className="shrink-0 w-10 h-10 rounded-full bg-amber-50 flex items-center justify-center">
            <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            </svg>
          </div>
          <div className="min-w-0">
            <h3 id="area-ask-title" className="text-base font-semibold text-gray-900">พื้นที่จัดส่งพิเศษ</h3>
            <p className="mt-1.5 text-sm text-gray-600 leading-relaxed">
              {lines.map((line, i) => (
                <span key={i}>
                  {line}
                  {i < lines.length - 1 && <br />}
                </span>
              ))}
            </p>
          </div>
        </div>
        <div className="mt-5 flex gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 rounded-xl border border-gray-200 px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            ยกเลิก
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex-1 rounded-xl px-4 py-2.5 text-sm font-semibold text-white"
            style={{ backgroundColor: primaryColor || '#2563eb' }}
          >
            รับทราบ สั่งซื้อต่อ
          </button>
        </div>
      </div>
    </div>
  )
}
